import React from "react";
import { checkAdmin } from "../../Utils/Common";
import * as ListItems from "./ListItems";
import * as ModularItemList from "./ModularItemList";

export default function MainSidebarList() {
  const items = checkAdmin() ? ModularItemList : ListItems;

  return items ? (
    <div>
      {React.createElement(items["Dashboard"], { key: "dasdf" })}
      {Object.keys(items)
        .sort((a, b) => (b < a ? 1 : -1))
        .map((k, i) =>
          !k.includes("Logout") &&
          !k.includes("Settings") &&
          !k.includes("Dashboard")
            ? React.createElement(items[k], { key: i })
            : null
        )}
      {items["Settings"] &&
        React.createElement(items["Settings"], { key: "dsfdffd" })}
      {ListItems.Logout()}
    </div>
  ) : null;
}
